import React from 'react';
import Slider from "react-slick"
import { Link } from 'react-router-dom';
import banner_1 from '../../../assets/images/background/banner-one-image.jpg';
import banner_2 from '../../../assets/images/background/banner-one-image-3.jpg';
import banner_3 from '../../../assets/images/background/banner-one-image-4.jpg'


const Banner = () => {
    const bannerslider = {
        autoplay: true,
        arrows: false,
        dots: true,
        fade: true,
        slidesToScroll: 1,
        speed: 500,
        autoplaySpeed: 3000
    };

    return (
        <>
            <div className="banner-section-one">
                <Slider className="banner-silder-one" {...bannerslider}>
                    <div className="banner-slide-item-one">
                        <div className="banner-image-one">
                            <img
                                src={banner_1}
                                alt="banner-image"
                            />
                        </div>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-xxl-4 col-xl-5 col-lg-8">
                                    <div className="heading-box">
                                        <div className="banner-sub-title-one">
                                            <h2>
                                                Tips for marketing <br /> &amp; strategy
                                            </h2>
                                        </div>
                                        <h1 className="heading-title">
                                            Empower your <br />
                                            <span>business to the</span> <br />
                                            Next level
                                        </h1>
                                        <p className="heading-details lead">
                                            Leverage agile frameworks to provide a robust synopsis for high
                                            level overviews. Iterative approaches to collaborative .
                                        </p>
                                        <Link to="/Aboutus" className="btn btn-light btn-theme">
                                            View More +
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="banner-slide-item-one">
                        <div className="banner-image-one">
                            <img
                                src={banner_2}
                                alt="banner-image"
                            />
                        </div>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-xxl-4 col-xl-5 col-lg-6">
                                    <div className="heading-box">
                                        <div className="banner-sub-title-one">
                                            <h2>
                                                Tips for marketing <br /> &amp; strategy
                                            </h2>
                                        </div>
                                        <h1 className="heading-title">
                                            Empower your <br />
                                            <span>business to the</span> <br />
                                            Next level
                                        </h1>
                                        <p className="heading-details lead">
                                            Leverage agile frameworks to provide a robust synopsis for high
                                            level overviews. Iterative approaches to collaborative .
                                        </p>
                                        <Link to="/Aboutus" className="btn btn-light btn-theme">
                                            View More +
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="banner-slide-item-one">
                        <div className="banner-image-one">
                            <img
                                src={banner_3}
                                alt="banner-image"
                            />
                        </div>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-xxl-4 col-xl-5 col-lg-6">
                                    <div className="heading-box">
                                        <div className="banner-sub-title-one">
                                            <h2>
                                                Tips for marketing <br /> &amp; strategy
                                            </h2>
                                        </div>
                                        <h1 className="heading-title">
                                            Empower your <br />
                                            <span>business to the</span> <br />
                                            Next level
                                        </h1>
                                        <p className="heading-details lead">
                                            Leverage agile frameworks to provide a robust synopsis for high
                                            level overviews. Iterative approaches to collaborative .
                                        </p>
                                        <Link to="/Aboutus" className="btn btn-light btn-theme">
                                            View More +
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Slider>
                <div id="slider-info" />
            </div>

        </>
    )
}

export default Banner
